import { isDefined } from '@sgme/fp';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedDate } from 'components/shared/Intl';
import { DatesListReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC, Fragment } from 'react';

export interface ProductSummaryDatesListFieldProps {
  node: DatesListReadonlyValueDefinition;
}

export const ProductSummaryDatesListField: FC<ProductSummaryDatesListFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);
  const translationKey = node.translationKey ?? node.id;
  const dates = data?.map(date => new Date(date));

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      {isDefined(dates) && (
        <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
          {dates.map((date, index) => (
            <Fragment key={`product-summary-field-${node.id}-${date}`}>
              <FormattedDate value={date} year="numeric" month="short" day="2-digit" />
              {index < dates.length - 1 && ' / '}
            </Fragment>
          ))}
        </p>
      )}
    </SummaryFieldRow>
  );
};

ProductSummaryDatesListField.displayName = 'ProductSummaryDatesListField';
